module.exports = {
  defaultLanguage: 'es',
  languages: ['es', 'en'],
  siteTitle: 'SEAT Factory Tours',
};
